import { ADS_ROUTE_TITLES } from '../pages/ads/adsNavigation';

/**
 * 將登入回傳的權限樹轉為側欄選單（僅保留有 path 的二級頁面）
 */
export function buildSidebarGroups(permissions) {
  if (!Array.isArray(permissions)) {
    return [];
  }

  return permissions
    .filter((module) => module.sort > 0 || hasNavigableChild(module))
    .map((module) => ({
      id: module.id,
      title: module.title,
      path: module.path,
      children: collectPageChildren(module.subMenu),
    }))
    .filter((group) => group.children.length > 0);
}

function hasNavigableChild(module) {
  return collectPageChildren(module.subMenu).length > 0;
}

function collectPageChildren(subMenu) {
  if (!Array.isArray(subMenu)) {
    return [];
  }

  return subMenu
    .filter((item) => item.path)
    .sort((a, b) => (a.sort || 0) - (b.sort || 0))
    .map((item) => ({
      id: item.id,
      title: item.title,
      path: item.path,
    }));
}

/** 依 path 從權限樹找頁面標題 */
export function findPageTitle(permissions, pathname) {
  if (pathname === '/') {
    return '首頁';
  }

  for (const module of permissions || []) {
    for (const child of module.subMenu || []) {
      if (child.path === pathname) {
        return child.title;
      }
    }
  }

  if (ADS_ROUTE_TITLES[pathname]) {
    return ADS_ROUTE_TITLES[pathname];
  }

  return pathname;
}
